import { icon } from "../../../config";

/** ids for PanelBar sections */
export const TEAM_SETTING_SECTION_IDS = {
  PROJECT_INFORMATION: "team-settings-project-information",
  PROJECT_CONFIGURATION: "team-settings-project-configuration",
  PROJECT_STAGES: "team-settings-project-stages",
  LOGS: "team-settings-logs",
};

/** Initial / reset expanded sections when opening the drawer or switching project */
  export const TEAM_SETTING_DEFAULT_EXPANDED = [TEAM_SETTING_SECTION_IDS.PROJECT_INFORMATION];

/**
 * Left rail navigation
 */
export const teamSettingSidebarNavOptions = [
  {
    id: TEAM_SETTING_SECTION_IDS.PROJECT_INFORMATION,
    title: "Project Information",
    icon: icon?.WORK,
  },
  {
    id: TEAM_SETTING_SECTION_IDS.PROJECT_CONFIGURATION,
    title: "Project Configuration",
    icon: icon?.CIRCLEPLUS,
  },
  {
    id: TEAM_SETTING_SECTION_IDS.PROJECT_STAGES,
    title: "Project Stages",
    icon: icon?.SQUARE_KANBAN,
  },
  {
    id: TEAM_SETTING_SECTION_IDS.LOGS,
    title: "Logs",
    icon: icon?.ACTIVITY_HISTORY,
  },
];
